"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var StorefrontCollection = _interopRequireWildcard(require("./StorefrontCollection"));

var _default = [StorefrontCollection.POPULAR, StorefrontCollection.NEW, StorefrontCollection.FREE, StorefrontCollection.FOR_MARKETING_TEAMS, StorefrontCollection.FOR_SALES_TEAMS, StorefrontCollection.FOR_CUSTOMER_SUCCESS_TEAMS, StorefrontCollection.FOR_STARTUPS, StorefrontCollection.FOR_AGENCIES, StorefrontCollection.HOMEMADE, StorefrontCollection.PIESYNC, StorefrontCollection.CMS, StorefrontCollection.ABM];
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/storefrontCollectionOrder.js
// module id = 215
// module chunks = 209 210 211 212 213